import {
  ref,
  onMounted,
  nextTick,
  computed,
  onDeactivated,
  onActivated,
} from "vue"
import { ElIcon } from "element-plus"
import PointsMall from "@/components/PointsMall/PointsMall.vue"
import { ArrowRightBold, MoreFilled } from "@element-plus/icons-vue"
import {
  pcWechatType,
  getPoints,
  wechatAuthorization,
  gameDetail,
  getPayForOtherLogin,
  addShoppingCart,
  submitShoppingCart,
  newGetRoleList,
  saveRecentRole,
  freeGift,
  reward,
} from "@/api/api"
import { showToast, Popup, showDialog, Skeleton } from "vant"
import "vant/lib/index.css"
import bus from "@/lib/bus"
import { useRouter } from "vue-router"
import QRCode from "qrcodejs2"
import { buriedLogger, platformPayment, wechatShareAction } from "@/utils/utils"
import Decimal from "decimal.js"
import { debounce } from "es-toolkit"
import Clipboard from "clipboard"
export default {
  name: "PayList",
  components: {
    ElIcon,
    ArrowRightBold,
    MoreFilled,
    [Popup.name]: Popup,
    [showDialog.name]: showDialog,
    [Skeleton.name]: Skeleton,
    PointsMall,
  },
  setup() {
    let resultSheetFirIndex = 0 //结算页参数
    let resultSheetSecIndex = 0 //结算页参数
    // 选择的区服
    const role_id = ref("")
    const roleIndex = ref(0) //选择角色的序号
    const payType = ref("alipay") //支付类型
    // 生成微信支付二维码
    const showWechatCode = ref(false)
    const wechatTradeNo = ref("")
    const qrcode = () => {
      const dom = document.getElementById("qrcode")
      const url = document.location.toString()
      const arrUrl = url.split("//")
      var start = arrUrl[1].split("/")
      /* eslint-disable */
      new QRCode("qrcode", {
        width: dom.clientWidth,
        height: dom.clientHeight,
        text: `${arrUrl[0]}//${start[0]}/gamepaypage?cashier=${wechatTradeNo.value}`,
        colorDark: "#5258A9",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      })
    }
    // 判断是否为移动端
    const payMethods = ref("wap") //支付类型:web电脑，app应用端，wap手机h5支付, mp为微信jssdk支付，微信PC为scan
    const isMobile = () => {
      let userAgentInfo = navigator.userAgent
      let Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod",
      ]
      let getArr = Agents.filter((i) => userAgentInfo.includes(i))
      return getArr.length
        ? (payMethods.value = "wap")
        : (payMethods.value = "web")
    }
    const showAliPay = ref(false)
    const isWeiXin = () => {
      const ua = window.navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        showAliPay.value = false
        payType.value = "wechat"
        getOpenId()

        if (ua.match(/windowswechat/i) == "windowswechat") {
          payMethods.value = "scan"
        } else {
          payMethods.value = "mp"
        }
      } else {
        showAliPay.value = true
        return isMobile()
      }
    }
    const loginType = ref(1)
    //累计充值底部进度条计算距离
    const longW = ref(0)
    const hLongW = ref(0)
    const iconW = ref(0)
    const dottedLeft = ref(0)
    const dottedW = ref(0)
    const progressWidth = ref(0)
    const rechargeBodyWidth = ref(0)
    const leftW = (e) => {
      let type = 0
      if (e < 0) {
        if (rechargeCategoryList.value[0].is_rewards == 1) {
          type = rechargeCategoryList.value.length
        } else type = 0
      } else type = e
      rechargeBodyWidth.value = document
        .getElementById("recharge-block-container-sec")
        .getBoundingClientRect().width
      console.log(rechargeBodyWidth.value)
      if (80 * rechargeCategoryList.value.length < rechargeBodyWidth.value) {
        progressWidth.value = rechargeBodyWidth.value
      } else progressWidth.value = 80 * rechargeCategoryList.value.length
      setTimeout(() => {
        let hMaxW = document
          .getElementById("hrecharge-icon-list")
          .getBoundingClientRect().width
        let beginIconsec = document
          .getElementById("h-begin-icon")
          .getBoundingClientRect().right
        if (type == rechargeCategoryList.value.length) {
          hLongW.value = hMaxW
          iconW.value =
            document
              .getElementById(`hrecharge-icon-${type - 1}`)
              .getBoundingClientRect().right -
            beginIconsec -
            14
          return
        }
        let endIconsec = document
          .getElementById(`hrecharge-icon-${type}`)
          .getBoundingClientRect().right

        hLongW.value = endIconsec - beginIconsec - 12
        iconW.value = endIconsec - beginIconsec - 14
        if (type == 0) {
          dottedLeft.value = 0
          dottedW.value = endIconsec - beginIconsec - 12
        } else if (type == rechargeCategoryList.value.length) {
          dottedW.value = 0
          dottedLeft.value = 0
        } else {
          let hEndDotted = document
            .getElementById(`hrecharge-icon-${type - 1}`)
            .getBoundingClientRect().right
          dottedW.value = endIconsec - hEndDotted - 8
          dottedLeft.value = hEndDotted - beginIconsec
        }
      }, 500)
    }
    const logger = ref("")
    const container = ref(null)
    const intervalId = ref(null)
    onMounted(() => {
      wechatShareAction()
      checkVersion()
      intervalId.value = setInterval(checkVersion, 60 * 60 * 1000)
      gameId.value = route.currentRoute.value.query.gameId
      localStorage.setItem("gameId", gameId.value)
      // 当前页面为测试服环境不触发阿里云埋点
      const currentUrl = window.location.href
      if (
        currentUrl.includes("pay.qingcigame.com") &&
        !currentUrl.includes("tpay.qingcigame.com")
      ) {
        const bl = buriedLogger("qc-recharge-platform", "游戏支付详情页面")
        logger.value = bl
        logger.value.sum(`当前的游戏ID${gameId.value}`)
      }
      if (
        localStorage.getItem("token") &&
        !route.currentRoute.value.query.token
      ) {
        loginType.value = 2
        mobile.value = localStorage.getItem("mobile")
        interPage()
      } else if (route.currentRoute.value.query.token) {
        LoginByNoSignIn()
      } else {
        interPage()
      }
      isWeiXin()
      // 监听登录
      bus.$on("login", () => {
        roleList.value = {}
        loginType.value = 2
        mobile.value = localStorage.getItem("mobile")
        channelType.value = 1
        choiceItem.value = ""
        choiceIndex.value = 0
        gameId.value = route.currentRoute.value.query.gameId
        interPage()
      })
    })
    //免密登录
    const LoginByNoSignIn = () => {
      getPayForOtherLogin({
        token: route.currentRoute.value.query.token,
      }).then((res) => {
        if (res.code == 200) {
          localStorage.setItem("token", res.data.access_token)
          localStorage.setItem("mobile", res.data.mobile)
          bus.$emit("sendToken", res.data.access_token)
          loginType.value = 2
          mobile.value = res.data.mobile
          if (!res.data.role_id) {
            return interPage()
          }
          role_id.value = res.data.role_id
          chooseGameList.value = res.data
          sysTem.value = res.data.os || "android"
          getListDetails()
        } else showToast(res.message)
      })
    }
    // 微信授权
    const getOpenId = () => {
      wechatAuthorization().then((res) => {
        if (res.data.open_id) {
          localStorage.setItem("openId", res.data.open_id)
          return
        }
      })
    }

    const list = ref([]) //代金券列表
    const otherList = ref([]) //其他商品列表
    const choiceItem = ref({})
    const route = useRouter()
    const gameId = ref(0) //当前的游戏ID
    // 获取游戏充值商品详情
    const gameListTop = ref([]) //光子服正式服列表
    const nowGameListType = ref(0)
    const amountPaid = ref(0) //累计充值已充值金额
    const distanceAmount = ref(0) //距离下一个奖励的金额
    const rechargeCategoryList = ref([]) //累计充值标题
    const rechargeTitle = ref("")
    const rechargePhase = ref(0) //累计充值阶段
    const gwcPayType = ref(1) //购物车支付类型,1为直接支付2为从购物车支付
    const skuListSec = ref([]) //购物车列表（单个商品点击立即支付用）

    let initType = false //判断是否第一次初始化列表数据
    const isActivity = ref(true)
    // 获取官方充值列表信息
    const totalPrice = ref(new Decimal(0)) //总价格
    const getListDetails = () => {
      skuListSec.value = []
      gameDetail(
        gameId.value,
        chooseGameList.value.role_id || "",
        chooseGameList.value.dist_id || chooseGameList.value.server_id || ""
      ).then((res) => {
        if (res.data.list && res.data.list.length > 0) {
          gameListTop.value = res.data.list
          gameListTop.value.forEach((item) => {
            if (item.game_id == gameId.value) {
              list.value = item
              localStorage.setItem("popupType", list.value.popup || 1) //分享弹窗类型 1 弹窗  2 不弹
              if (list.value.suspension_button_img) showActiveIcon.value = true
              if (list.value.category_related_game.length > 0) {
                // 置顶活动顺序调整
                const categoryGames = list.value.category_related_game
                categoryGames.forEach((game) => {
                  if (game.is_top === 1 || game.is_top === "1") {
                    const officialProps = game.game_pay_official_prop
                    const itemsToMove = []
                    officialProps.forEach((prop) => {
                      if (
                        prop.quantity >= 0 &&
                        (prop.quantity === prop.game_stock ||
                          prop.quantity === prop.interflow_stock)
                      ) {
                        itemsToMove.push(prop)
                      }
                    })
                    // 过滤出不需要移动的元素
                    const remainingItems = officialProps.filter(
                      (prop) =>
                        !(
                          prop.quantity >= 0 &&
                          (prop.quantity === prop.game_stock ||
                            prop.quantity === prop.interflow_stock)
                        )
                    )

                    // 重新组合数组
                    game.game_pay_official_prop = [
                      ...remainingItems,
                      ...itemsToMove,
                    ]
                  }
                })
              }
              if (!chooseGameList.value.role_id && roleType == true) {
                showGameRole()
              }
              choiceItem.value = {}
              if (list.value.cart_open == 1) {
                isGwc.value = true
                initType = true
                updateGwcList()
              } else {
                isGwc.value = false
                totalPrice.value = new Decimal(0)
                gwcNum.value = 0
              }
              amountPaid.value = item.user_bonus_price || 0
              rechargeCategoryList.value = item.bonus_list || []
              if (rechargeCategoryList.value.length > 0) {
                rechargeTitle.value = item.bonus_detail
                let index = rechargeCategoryList.value.findIndex(
                  (item) => item.is_rewards != 1
                )
                if (index < 0) {
                  if (rechargeCategoryList.value[0].is_rewards == 1) {
                    rechargePhase.value = rechargeCategoryList.value.length - 1
                  } else rechargePhase.value == 0
                } else rechargePhase.value = index
                distanceAmount.value =
                  rechargeCategoryList.value[rechargePhase.value].price -
                    amountPaid.value >
                  0
                    ? (
                        rechargeCategoryList.value[rechargePhase.value].price -
                        amountPaid.value
                      ).toFixed(2)
                    : 0
                hLongW.value = 0
                longW.value = 0
                dottedW.value = 0
                dottedLeft.value = 0
                // nextTick(() => {
                //   leftW(index)
                // })
              }
            }
          })
        }
      })
    }
    const randomRange = (min, max) => {
      // min最小值，max最大值
      return Math.floor(Math.random() * (max - min)) + min
    }
    // 调取支付
    const tradeNum = ref("") //PC微信轮询订单
    const wechatPayTest = ref("")
    const showWechatAlipay = ref(false)
    // 验证当前账户状态实付
    const testNowType = () => {
      if (!localStorage.getItem("token")) {
        return bus.$emit("click") //未登录调取登录接口
      }
      const ua = window.navigator.userAgent.toLowerCase()
      if (
        ua.match(/MicroMessenger/i) == "micromessenger" &&
        payType.value == "alipay"
      ) {
        showWechatAlipay.value = true
        return false
      }
      if (list.value.status == 2) {
        showDialog({
          title: "温馨提示",
          message: "游戏维护期间，暂时无法为您充值，给您造成的不便敬请谅解。",
          confirmButtonColor: "#8383FF",
          confirmButtonText: "好的",
        })
        return false
      }
      if (!chooseGameList.value.role_id) {
        getRoleNew()
        return false
      }
      return true
    }
    const skuList = ref([]) //购物车上传数据列表
    // 购物车描述拼接
    const skuDesc = (e) => {
      let desc = []
      console.log(e)
      let priceNum = 0
      e.forEach((item) => {
        if (item.channel == 1) {
          priceNum += Number(item.bonus_price) * item.num
        } else desc.push(item.sku_desc)
      })
      if (priceNum > 0) {
        desc.push(`${priceNum}${e[0].type}`)
      }
      // 数组转字符串
      return desc.join(",")
    }
    // 购物车支付
    const gwcSetPay = () => {
      if (Number(choiceItem.value.price) == 0) {
        return giftSetPay()
      }
      const nowType = testNowType()
      if (!nowType) return
      if (gwcPayType.value == 1 && buyNowStep.value >= 1) {
        totalPrice.value = new Decimal(0)
        const price = new Decimal(Number(choiceItem.value.price)) // 确保 price 是数值类型
        totalPrice.value = totalPrice.value.plus(price.times(buyNowStep.value))
        finalPriceResult.value = doublePriceCompute()
      }
      if (payMethods.value == "web" && payType.value == "wechat") {
        payMethods.value = "scan"
      }
      if (payMethods.value == "scan" && payType.value != "wechat") {
        payMethods.value = "web"
      }
      const url = document.location.toString()
      const arrUrl = url.split("//")
      const start = arrUrl[1].split("/")
      let returnUrl = `${arrUrl[0]}//${start[0]}/gamepaypage?type=2`
      if (payMethods.value == "wap" && payType.value == "wechat") {
        returnUrl = `${arrUrl[0]}//${start[0]}/gamepaypage?type=4`
      }
      let prams = {
        pay_type: payType.value, //alipay支付宝   wechat微信   pay_behalf 代付
        game_id: gameId.value,
        pay_method: payMethods.value,
        sku_desc:
          gwcPayType.value == 1
            ? skuDesc(skuListSec.value)
            : skuDesc(skuList.value),
        sku_list:
          gwcPayType.value == 1
            ? JSON.stringify(skuListSec.value)
            : JSON.stringify(skuList.value),
        price: totalPrice.value.toNumber(),
        currency: "CNY",
        os: sysTem.value,
        return_url: returnUrl,
        server_id:
          chooseGameList.value.dist_id || chooseGameList.value.server_id,
        role_id: chooseGameList.value.role_id,
        zone: chooseGameList.value.zone || chooseGameList.value.server_id,
        dist_name:
          chooseGameList.value.dist_name || chooseGameList.value.server_name,
        roles_name:
          chooseGameList.value.nickname || chooseGameList.value.role_name,
      }
      submitShoppingCart(prams)
        .then((res) => {
          if (res.code != 200) return showToast(res.message)
          if (payType.value === "alipay") {
            document.getElementById("aliPayBtn").innerHTML = res.data.order
            document.forms["alipaysubmit"].submit()
          }
          if (payType.value === "wechat") {
            if (payMethods.value === "scan") {
              // PC微信扫码支付
              wechatTradeNo.value = res.data.cashier
              tradeNum.value = res.data.trade_no
              showWechatCode.value = true
              nextTick(() => {
                qrcode()
                setTimeout(() => {
                  pcWechat()
                }, 2000)
              })
            } else if (payMethods.value === "wap") {
              // 移动端非微信浏览器调用微信支付
              window.location.href = res.data.redirect_uri
            } else if (payMethods.value === "mp") {
              // 移动端微信浏览器内调用微信支付
              bus.$emit("closePayHeader")
              route.push({
                path: `./gamepaypage`,
                query: {
                  cashier: res.data.cashier,
                },
              })
            }
          } else if (payType.value === "pay_behalf") {
            bus.$emit("closePayHeader")
            // 代付
            route.push({
              path: `./payforanother`,
              query: {
                orderid: res.data.order_no,
                gameid: gameId.value,
                ordertype: 2,
              },
            })
          } else if (res === "unnamed") {
            realNamePopup.value = true
          }
        })
        .catch((err) => {
          console.error(err.message)
        })
    }
    //免费礼包接口
    const giftSetPay = () => {
      freeGift({
        product_id: choiceItem.value.id,
        game_id: gameId.value,
        role_id: chooseGameList.value.role_id,
        os: sysTem.value,
        server_id:
          chooseGameList.value.dist_id || chooseGameList.value.server_id,
        role_name:
          chooseGameList.value.nickname || chooseGameList.value.role_name,
        server_name:
          chooseGameList.value.dist_name || chooseGameList.value.server_name,
      }).then((res) => {
        if (res.code != 200) return showToast(res.message)
        if (res.code == 200) {
          showH5PayPopup.value = false
          showToast("领取礼包成功")
          getPointsDetail()
          getListDetails()
        }
      })
    }
    // 普通支付
    const setPay = () => {
      if (Number(choiceItem.value.price) == 0) {
        return giftSetPay()
      }
      const nowType = testNowType()
      if (!nowType) return
      showH5Details.value = false
      if (payMethods.value == "web" && payType.value == "wechat") {
        payMethods.value = "scan"
      }
      if (payMethods.value == "scan" && payType.value != "wechat") {
        payMethods.value = "web"
      }
      const url = document.location.toString()
      const arrUrl = url.split("//")
      const start = arrUrl[1].split("/")
      let returnUrl = `${arrUrl[0]}//${start[0]}/gamepaypage?type=2`
      if (payMethods.value == "wap" && payType.value == "wechat") {
        returnUrl = `${arrUrl[0]}//${start[0]}/gamepaypage?type=4`
      }
      let prams = {
        pay_type: payType.value, //alipay支付宝   wechat微信   pay_behalf 代付
        game_id: gameId.value,
        pay_method: payMethods.value,
        sku_id:
          channelType.value == 2
            ? choiceItem.value.sku_id
            : choiceItem.value.id,
        sku_desc: choiceItem.value.name,
        price: choiceItem.value.price,
        currency: "CNY",
        os: sysTem.value,
        return_url: returnUrl,
        server_id:
          chooseGameList.value.dist_id || chooseGameList.value.server_id,
        role_id: chooseGameList.value.role_id,
        zone: chooseGameList.value.zone || chooseGameList.value.server_id,
        dist_name:
          chooseGameList.value.dist_name || chooseGameList.value.server_name,
        roles_name:
          chooseGameList.value.nickname || chooseGameList.value.role_name,
        prop_id: channelType.value == 2 ? choiceItem.value.id : "",
        channel: channelType.value,
      }
      platformPayment(prams)
        .then((res) => {
          if (payType.value === "alipay") {
            document.getElementById("aliPayBtn").innerHTML = res.data.order
            document.forms["alipaysubmit"].submit()
          }
          if (payType.value === "wechat") {
            if (payMethods.value === "scan") {
              // PC微信扫码支付
              wechatTradeNo.value = res.data.cashier
              tradeNum.value = res.data.trade_no
              showWechatCode.value = true
              nextTick(() => {
                qrcode()
                setTimeout(() => {
                  pcWechat()
                }, 2000)
              })
            } else if (payMethods.value === "wap") {
              // 移动端非微信浏览器调用微信支付
              window.location.href = res.data.redirect_uri
            } else if (payMethods.value === "mp") {
              // 移动端微信浏览器内调用微信支付
              bus.$emit("closePayHeader")
              route.push({
                path: `./gamepaypage`,
                query: {
                  cashier: res.data.cashier,
                },
              })
            }
          } else if (payType.value === "pay_behalf") {
            bus.$emit("closePayHeader")
            // 代付
            route.push({
              path: `./payforanother`,
              query: {
                orderid: res.data.order_no,
                gameid: gameId.value,
                ordertype: 2,
              },
            })
          } else if (res === "unnamed") {
            realNamePopup.value = true
          }
        })
        .catch((err) => {
          console.error(err.message)
        })
    }
    //监听微信支付二维码弹窗关闭
    const qrcodes = ref(null)
    const closeQrcode = () => {
      qrcodes.value.innerHTML = ""
      clearTimeout(wechatPayTest.value)
    }
    // 区服选择弹窗
    let isFormInit = "" //判断点击事件是否来自切换角色
    const show = ref(false)
    const showGameRole = (e) => {
      isFormInit = e
      if (!localStorage.getItem("token")) {
        bus.$emit("click")
        bus.$emit("loginOut") //未登录调取登录接口
        roleType = false
        getListDetails()
        return
      }
      getPointsDetail()
      getRoleNew()
    }
    // 选取购买的物品
    const choiceIndex = ref(0)
    const channelType = ref(1) //渠道，1代金券2为其他道具
    const choicePay = (e, index, type, subIndex) => {
      const gameStock = Number(e.interflow_stock)
        ? Number(e.interflow_stock)
        : Number(e.game_stock)
      const quantity = Number(e.quantity)

      if (quantity >= 0) {
        if (gameStock === quantity && quantity === 0) {
          showToast("当前商品售罄")
          return
        }
        if (quantity <= gameStock) {
          showToast("不能再点啦～商品已达最大购买限制")
          return
        }
      }

      choiceItem.value = e
      choiceIndex.value = index
      resultSheetFirIndex = index || 0
      resultSheetSecIndex = subIndex || 0
      channelType.value = type
      buyNowProduct.value = e
      skuListSec.value = []
      if (type == 2) {
        skuListSec.value.push({
          sku_id: e.sku_id,
          channel: 2,
          prop_id: e.id,
          get num() {
            return buyNowStep.value
          },
          sku_desc: e.name,
        })
      } else {
        skuListSec.value.push({
          sku_id: e.id,
          channel: 1,
          prop_id: 0,
          get num() {
            return buyNowStep.value
          },
          sku_desc: e.name,
          type: e.type,
          bonus_price: e.bonus_price,
        })
      }

      if (isGwc.value) {
        buyNow(e, resultSheetFirIndex, channelType.value, resultSheetSecIndex)
        return
      }

      showH5Pay()
    }
    // 获取当前页面信息
    const interPage = () => {
      bus.$emit("showPayHeader")
      if (!gameId.value) {
        route.push({
          path: `./home`,
        })
        return
      }
      showGameRole()
    }
    // 组件被销毁时
    onDeactivated(() => {
      bus.$off("login")
      clearInterval(intervalId.value)
    })
    const pointsMallContainer = ref("")
    onActivated(() => {
      if (localStorage.getItem("isFromRecord")) {
        showCashCoupon.value = false
        localStorage.removeItem("isFromRecord")
        nextTick(() => {
          bus.$emit("lotteryType", list.value.is_lottery)
          if (roleList.value.sysTem) {
            bus.$emit("roleInfo", roleList.value)
          }
          pointsMallContainer.value.changeTabToRoll()
        })
      }
    })
    const sysTem = ref("android") // 当前选择的系统
    // 选择角色的系统类型
    const chooseSystem = (item, index) => {
      let closeType = item.close //维护状态参数
      if (Number(closeType) === 1)
        return showToast(
          "游戏维护期间，暂时无法为您充值，给您造成的不便敬请谅解。"
        )
      if (gameRoleList.value[index].role_list.length == 0)
        return showToast("该区服暂无角色")
      gameRoleTitle.value = gameRoleList.value[index].title
      areaList.value = gameRoleList.value[index].role_list

      areaList.value.forEach((item) => {
        // item.os = gameRoleList.value[index].os
        if (item.is_last_login == 1) {
          chooseGameList.value = item
        }
      })
    }
    // 选择角色监听其系统类型
    const chooseRoleGameId = (e) => {
      sysTem.value = e.os
      gameId.value = e.game_id
    }
    // 获取账号的游戏角色
    const areaList = ref([]) //当前区分对应的角色列表
    const chooseArea = ref("请选择区服") //选择的区服
    const gameRoleList = ref([]) //角色列表
    const gameRoleTitle = ref("安卓") //区服客户端标题
    let roleType = true //防止商品列表死循环去获取角色

    //获取角色列表
    const getRoleNew = async () => {
      roleType = true
      let nowGameId = "" //当前的gameid
      try {
        const res = await newGetRoleList({
          game_id: gameId.value,
          os: "android",
          parent_id: list.value.parent_id || 0,
        })

        if (res.code !== 200 && res.code !== 401) {
          // js正则删除换行符
          const regex = /\\n/g
          const result = res.message.replace(regex, "\n")
          showToast(result)
          roleType = false
          getListDetails()
          return
        }

        if (res.data.length === 0) {
          getListDetails()
          roleType = false
          showToast("暂无角色")
          return
        }
        if (res.code !== 200) return
        gameRoleList.value = res.data
        gameRoleList.value.forEach((item) => {
          // 将最后支付的角色移动到开头
          item.role_list.forEach((role) => {
            role.game_id = item.game_id
            if (role.is_last_pay === 1) {
              item.role_list = [
                role,
                ...item.role_list.filter((r) => r !== role),
              ]
            }
          })

          // 将最后登录的角色移动到开头
          item.role_list.forEach((role) => {
            if (role.is_last_login === 1) {
              item.role_list = [
                role,
                ...item.role_list.filter((r) => r !== role),
              ]
            }
          })
        })

        const foundItem = gameRoleList.value.find((item) => {
          const subItem = item.role_list.find(
            (subItem) => subItem.is_last_login === 1
          )
          if (subItem) {
            areaList.value = item.role_list
            // areaList.value.forEach((subItem) => {
            //   subItem.os = item.os
            // })
            gameRoleTitle.value = item.title
            chooseGameList.value = subItem
            roleList.value = subItem
            bus.$emit("roleInfo", roleList.value) //更新积分商城页面的信息
            bus.$emit("lotteryType", list.value.is_lottery)
            roleList.value.sysTem = subItem.os
            sysTem.value = subItem.os
            if (gameId.value !== subItem.game_id) {
              nowGameId = subItem.game_id
            }
            return true
          } else {
            const firstList = gameRoleList.value.find(
              (item) => item.role_list.length > 0
            )
            areaList.value = firstList.role_list
            // areaList.value.forEach((subItem) => {
            //   subItem.os = firstList.os
            // })
            gameRoleTitle.value = firstList.title
          }
          return false
        })

        const found = !!foundItem

        if (isFormInit === "show" || !chooseGameList.value.role_id || !found) {
          show.value = true
          return
        }

        if (nowGameId) {
          gameId.value = nowGameId
        }

        roleType = false
        getListDetails()
      } catch (error) {
        console.error("Error fetching role list:", error)
        roleType = false
        getListDetails()
      }
    }

    // 切换支付方式
    const changePay = (e) => {
      showType.value = false
      payType.value = e
    }
    // 确定选择角色
    const chooseGameList = ref({}) //选择的角色的信息
    const roleList = ref({}) //选择的角色（传递给积分商城页用）
    const confirmChoose = () => {
      if (!chooseGameList.value.role_id) {
        return showToast("请选择区服信息")
      }
      bus.$emit("sendPointMall", chooseGameList.value)
      saveRecentRole({
        game_id: gameId.value,
        role_id: chooseGameList.value.role_id,
        parent_game_id: gameRoleList.value[0].game_id,
      })
      roleList.value = chooseGameList.value
      roleList.value.sysTem = sysTem.value
      bus.$emit("roleInfo", roleList.value)
      bus.$emit("lotteryType", list.value.is_lottery)
      if (gameId.value) {
        localStorage.setItem("gameId", gameId.value)
      }
      show.value = false
      if (showH5Details.value) {
        showH5PayPopup.value = true
      }
      getListDetails()
    }
    // 微信订单状态轮询查询
    const pcWechat = () => {
      pcWechatType({
        trade_no: tradeNum.value,
        game_id: gameId.value,
      }).then((res) => {
        if (res.code == 404) {
          wechatPayTest.value = setTimeout(() => {
            pcWechat()
          }, 3000)
        } else if (res.code == 200) {
          showWechatCode.value = false
          setTimeout(() => {
            route.push({
              path: `./orderpage`,
            })
          }, 2000)
        }
      })
    }
    // 用户服务协议
    const goRuler = () => {
      window.open(list.value.service_url, "_blank")
    }
    //注销监听
    bus.$on("clear", () => {
      choiceIndex.value = 0
      role_id.value = ""
      pointsNum.value = 0
      chooseGameList.value = {}
      skuList.value = []
      gwcList.value = []
      gwcNum.value = 0
      gwcPayType.value = 1
      mobile.value = ""
      loginType.value = 1
      roleList.value = {}
      gameId.value =
        gameListTop.value.length > 0
          ? gameListTop.value[0].game_id
          : route.currentRoute.value.query.gameId
      getListDetails()
    })
    const showH5PayPopup = ref(false) // 非购物车支付弹窗
    const showGwcPopup = ref(false) //购物车弹窗
    const showH5Details = ref(false)
    const showH5Pay = () => {
      const nowType = testNowType()
      if (!nowType) return
      gwcPayType.value = 1
      buyNowStep.value = 1
      showH5PayPopup.value = true
    }
    // 调起登录弹窗
    const mobile = ref("")
    const loginBtn = () => {
      return bus.$emit("click") //未登录调取登录接口
    }
    // 注销点击
    const loginOut = () => {
      choiceIndex.value = 0
      role_id.value = ""
      pointsNum.value = 0
      chooseGameList.value = {}
      skuList.value = []
      gwcList.value = []
      gwcNum.value = 0
      gwcPayType.value = 1
      mobile.value = ""
      loginType.value = 1
      roleList.value = {}
      sysTem.value = "android"
      bus.$emit("loginOut")
      if (route.currentRoute.value.query.token) {
        const url = new URL(window.location.href)
        url.searchParams.delete("token")
        window.location.href = url.toString()
        return
      }
      getListDetails()
    }
    // 关闭区服选择弹窗
    const closeRolePopup = () => {
      showH5Details.value = false
    }
    const realNamePopup = ref(false) //实名认证弹窗
    const cardIdNum = ref("") //身份证
    const userName = ref("") //姓名
    // 身份证校验
    const validateIDCard = (idCard) => {
      // Regular expression to match the ID card pattern
      var pattern =
        /^[1-9]\d{5}(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[1-2]\d|3[0-1])\d{3}[\dX]$/
      // Check if the ID card matches the pattern
      if (pattern.test(idCard)) {
        return true
      } else {
        return false
      }
    }
    const updataUserBtn = () => {
      if (!cardIdNum.value || !userName.value)
        return showToast("请填写完整信息")
      if (!validateIDCard(cardIdNum.value)) {
        return showToast("请输入正确的身份证格式")
      }
      updateUser({
        real_name: userName.value,
        card_no: cardIdNum.value,
      }).then((res) => {
        if (res.code == 200) {
          showToast("实名认证成功！")
          realNamePopup.value = false
        } else {
          showToast(res.message)
        }
      })
    }
    const getPointsDetail = () => {
      if (isFormInit === "show") return
      getPoints().then((res) => {
        if (res.code == 200) {
          pointsNum.value = res.data.points
          localStorage.setItem("pointsNum", pointsNum.value)
        }
      })
    }
    const showCashCoupon = ref(true) //是否为代金券页面
    const pointsNum = ref(0) //当前积分
    bus.$on("points", (e) => {
      pointsNum.value = e
    })
    // 兑换记录跳转
    const goExchangePage = () => {
      if (!mobile.value) return bus.$emit("click") //未登录调取登录接口
      route.push({
        path: `./exchangerecord`,
      })
    }
    // 积分记录跳转
    const goPointsDetail = () => {
      if (!mobile.value) return bus.$emit("click") //未登录调取登录接口
      route.push({
        path: `./integraldetail`,
      })
    }
    // 前往积分商城
    const goJfMallPage = () => {
      showCashCoupon.value = false
      localStorage.removeItem("isFromRecord")
      nextTick(() => {
        bus.$emit("lotteryType", list.value.is_lottery)
        if (roleList.value.sysTem) {
          bus.$emit("roleInfo", roleList.value)
        }
      })
    }
    const latelyPayRole = ref("")
    const kfBtn = () => {
      bus.$emit("showKf")
    }
    const showType = ref(false)
    const gwcNum = ref(0) //购物车数量

    const isGwc = ref(false) //是否开启购物车模块
    const imgAni = ref("")
    const clickBlock = ref({})

    const cart = ref(null) //购物车底部栏定位
    // 购物车动画
    const gwcAni = (i, event) => {
      const item = event
      const itemRect = item.getBoundingClientRect()
      const cartRect = cart.value.getBoundingClientRect()
      const bezierCurve = document.createElement("img")
      bezierCurve.src = i // 使用 item 作为图片的地址
      bezierCurve.style.position = "fixed"
      bezierCurve.style.width = "auto"
      bezierCurve.style.height = "50px"
      bezierCurve.style.objectFit = "contain" // 保证图片等比例缩小
      bezierCurve.style.pointerEvents = "none"
      document.body.appendChild(bezierCurve)

      const startX = itemRect.left + itemRect.width / 2
      const startY = itemRect.top + itemRect.height / 2
      const endX = cartRect.left + cartRect.width / 2
      const endY = cartRect.top + cartRect.height / 2

      bezierCurve.style.left = `${startX}px`
      bezierCurve.style.top = `${startY}px`
      bezierCurve.animate(
        [
          { transform: "translate(0, 0)" },

          {
            transform: `translate(${endX / 2 - startX - 100}px, ${
              endY - startY
            }px)`,
          },
        ],
        {
          duration: 1000,
          easing: "cubic-bezier(0.55, 0, 0.85, 0.36)",
          fill: "forwards",
        }
      ).onfinish = () => {
        document.body.removeChild(bezierCurve)
      }
    }
    const addPlus = () => {
      // setTimeout(() => {
      //   gwcAni(imgAni.value, clickBlock.value)
      // }, 100)
    }
    const storeInfo = (i, event) => {
      imgAni.value = i
      clickBlock.value = event.currentTarget
    }
    // 监听商品列表及非购物车结算页的步进器
    const stepperChange = debounce(() => {
      if (showGwcPopup.value == true) return
      gwcNum.value = Number(0)
      totalPrice.value = new Decimal(0) // 确保 totalPrice 是 Decimal 类型
      list.value.product.forEach((item) => {
        if (item.cart_num && item.cart_num > 0) {
          gwcNum.value += Number(item.cart_num)
          const price = new Decimal(Number(item.price)) // 确保 price 是数值类型
          totalPrice.value = totalPrice.value.plus(price.times(item.cart_num))
        }
      })
      list.value.category_related_game.forEach((item) => {
        item.game_pay_official_prop.forEach((subItem) => {
          if (subItem.cart_num && subItem.cart_num > 0) {
            gwcNum.value += Number(subItem.cart_num)
            const price = new Decimal(Number(subItem.price)) // 确保 price 是数值类型
            totalPrice.value = totalPrice.value.plus(
              price.times(subItem.cart_num)
            )
          }
        })
      })
      finalPriceResult.value = doublePriceCompute()
      if (!roleList.value) return
      updateGwcList()
    }, 300)

    // 封装购物车结算的数据
    const upLoadGwcList = () => {
      if (gwcList.value.length === 0) {
        return []
      }
      return gwcList.value.map((item) => {
        const commonFields = {
          sku_id: Number(item.type) === 3 ? item.sku_id : item.id,
          channel: Number(item.type) === 3 ? 2 : 1,
          prop_id: Number(item.type) === 3 ? item.id : 0,
          num: item.cart_num,
          sku_desc: item.name,
        }
        if (item.type !== 3) {
          return {
            ...commonFields,
            type: item.type,
            bonus_price: item.bonus_price,
          }
        }
        return commonFields
      })
    }

    // 上传购物车数据
    const updateCartList = () => {
      skuList.value = []
      skuList.value = upLoadGwcList()
      addShoppingCart({
        sku_list: JSON.stringify(skuList.value),
        role_id: chooseGameList.value.role_id,
        game_id: gameId.value,
      }).then(() => {})
    }
    // 触发商品列表的步进器
    const addToCart = (type, firIndex, secIndex) => {
      const nowType = testNowType()
      if (!nowType) return
      const CART_NUM_INCREMENT = 1

      let item

      if (type === "dc") {
        item = list.value.product[firIndex]
        if (!item) return
      } else {
        const category = list.value.category_related_game[firIndex]
        if (!category) return
        item = category.game_pay_official_prop[secIndex]
        if (!item) return

        if (Number(item.quantity) === 0) {
          showToast("不能再点啦～ 当前商品售罄")
          return
        }

        if (Number(item.quantity) <= Number(item.game_stock)) {
          showToast("不能再点啦～商品已达最大购买限制")
          return
        }
      }

      // 更新购物车数量和总价
      item.cart_num = CART_NUM_INCREMENT
      totalPrice.value = totalPrice.value.plus(new Decimal(item.price))
      finalPriceResult.value = doublePriceCompute()
      // 更新购物车信息
      gwcNum.value++
      updateGwcList()
    }

    const buyNowProduct = ref({}) //立即购买的商品
    const buyNowStep = ref(1) //结算页步进器
    // 立即购买
    const buyNow = (e, firIndex, type, secIndex = 0) => {
      const nowType = testNowType()
      if (!nowType || !e || firIndex === undefined) return

      const TYPE_PROP = 2
      const MAX_BUY_LIMIT_MSG = "不能再点啦～商品已达最大购买限制"
      const SOLD_OUT_MSG = "不能再点啦～ 当前商品售罄"
      if (type === TYPE_PROP) {
        const quantity = Number(e.quantity)
        const gameStock = Number(e.game_stock)
        const interflowStock = Number(e.interflow_stock)

        if (quantity === 0) {
          showToast(SOLD_OUT_MSG)
          return
        }

        if (
          quantity !== -1 &&
          (quantity <= gameStock || quantity <= interflowStock)
        ) {
          showToast(MAX_BUY_LIMIT_MSG)
          return
        }
      }

      choiceItem.value = e
      gwcPayType.value = 1
      resultSheetFirIndex = firIndex
      resultSheetSecIndex = secIndex
      buyNowStep.value = 1
      buyNowProduct.value = e
      channelType.value = type
      skuListSec.value = []

      const skuItem = {
        sku_id: e.sku_id || e.id,
        channel: type === TYPE_PROP ? 2 : 1,
        prop_id: type === TYPE_PROP ? e.id : 0,
        get num() {
          return buyNowStep.value
        },
        sku_desc: e.name,
      }

      if (type !== TYPE_PROP) {
        skuItem.type = e.type
        skuItem.bonus_price = e.bonus_price
      }
      skuListSec.value.push(skuItem)
      showH5PayPopup.value = true
    }

    // 非购物车结算页弹窗关闭监听
    const closeResultSheet = () => {
      buyNowStep.value = 0
      if (isGwc.value) {
        choiceItem.value = {}
      }
    }
    //非购物车结算页步进器监听
    const stepResultSheet = () => {
      if (buyNowStep.value == 0) {
        showH5PayPopup.value = false
        return
      }
    }
    // 购物车结算页步进器监听
    const stepperChangeSec = () => {
      for (let i = gwcList.value.length - 1; i >= 0; i--) {
        if (gwcList.value[i].cart_num == 0) {
          gwcList.value.splice(i, 1)
        }
      }
      if (gwcList.value.length == 0) {
        showGwcPopup.value = false
        gwcNum.value = Number(0)
      }
      updateGwcList()
    }
    const gwcList = ref([]) //购物车列表
    const showBonus = ref(false) //购物车列表赠送栏目显示
    const finalPriceResult = ref(0) //双倍积分最终计算结果（购物车用）
    // 购物车数据监听
    const updateGwcList = debounce(() => {
      gwcList.value = []
      gwcNum.value = Number(0)
      totalPrice.value = new Decimal(0)
      finalPriceResult.value = 0
      list.value.product.forEach((item) => {
        if (item.cart_num && item.cart_num > 0) {
          gwcList.value.push(item)
          gwcNum.value += Number(item.cart_num)
          const price = new Decimal(item.price)
          totalPrice.value = totalPrice.value.plus(price.times(item.cart_num))
        }
      })

      list.value.category_related_game.forEach((item) => {
        item.game_pay_official_prop.forEach((subItem) => {
          if (subItem.cart_num && subItem.cart_num > 0) {
            gwcList.value.push(subItem)
            gwcNum.value += Number(subItem.cart_num)
            const price = new Decimal(subItem.price)
            totalPrice.value = totalPrice.value.plus(
              price.times(subItem.cart_num)
            )
          }
        })
      })
      finalPriceResult.value = doublePriceCompute()
      // 上传购物车数据
      if (!chooseGameList.value.role_id || initType) {
        initType = false
        return
      }

      updateCartList()
    }, 300)
    // 打开购物车
    const openGwc = () => {
      const nowType = testNowType()
      if (!nowType) return
      gwcPayType.value = 2
      if (gwcList.value.length == 0) return showToast("购物车为空")
      gwcList.value.forEach((item) => {
        if (item.bonus) showBonus.value = true
      })
      skuList.value = upLoadGwcList()
      showH5PayPopup.value = false
      showGwcPopup.value = true
    }
    const scrollBot = ref(true)
    const handleScroll = () => {
      if (container.value) {
        const scrollTop = container.value.scrollTop
        const containerHeight = container.value.clientHeight
        const contentHeight = container.value.scrollHeight

        // 距离底部的距离
        const distanceToBottom = contentHeight - (scrollTop + containerHeight)
        if (distanceToBottom <= 220) {
          scrollBot.value = false
        } else scrollBot.value = true
      }
    }
    const debouncedHandleScroll = debounce(handleScroll, 300)
    // 从结算页添加商品到购物车
    const addToCartSec = () => {
      const stepValue = Number(buyNowStep.value)
      if (isNaN(stepValue)) {
        return showToast("无效的购买数量")
      }

      const price = new Decimal(buyNowProduct.value.price)
      if (price.isNaN()) {
        return showToast("无效的商品价格")
      }

      const totalPriceIncrement = price.times(stepValue)

      if (channelType.value === 1) {
        const product = list.value.product[resultSheetFirIndex]
        if (!product) return showToast("未找到商品")

        product.cart_num += stepValue
        totalPrice.value = totalPrice.value.plus(totalPriceIncrement)
        finalPriceResult.value = doublePriceCompute()
        gwcNum.value += stepValue
      } else {
        const categoryGame =
          list.value.category_related_game[resultSheetFirIndex]
        if (!categoryGame) return showToast("未找到商品")

        const gameProp =
          categoryGame.game_pay_official_prop[resultSheetSecIndex]
        if (!gameProp) return showToast("未找到商品")

        const addType = checkCart(gwcList.value, gameProp)
        if (!addType) {
          return showToast("当前选购的商品已达购买上限")
        }

        gameProp.cart_num += stepValue
        totalPrice.value = totalPrice.value.plus(totalPriceIncrement)
        finalPriceResult.value = doublePriceCompute()
        gwcNum.value += stepValue
      }

      showDialog({
        title: "添加成功",
      })
      updateGwcList()
    }

    // 检查当前添加购物车的商品是否超过购买限制
    const checkCart = (gwcList, gameProp) => {
      return gwcList.every(
        (item) =>
          !(
            item.id === gameProp.id &&
            item.cart_num >=
              Number(gameProp.quantity) - Number(gameProp.game_stock)
          )
      )
    }
    const payTypeClass = computed(() => {
      const payTypeClasses = {
        alipay: "alipay-bgc",
        wechat: "wechat-bgc",
        pay_behalf: "pay-other-bgc",
      }
      return payTypeClasses[payType.value] || ""
    })

    const payTypeText = computed(() => {
      const payTypeTexts = {
        alipay: "支付宝",
        wechat: "微信支付",
        pay_behalf: "找朋友帮忙付",
      }
      return payTypeTexts[payType.value] || ""
    })
    // 购物车滑动删除
    const delGwcList = (e) => {
      gwcList.value[e].cart_num = 0
      updateGwcList()
    }
    // 计算购物车里礼包代钞
    const totalBonusPrice = computed(() => {
      return gwcList.value.reduce((total, item) => {
        if (item.type != 3) {
          const bonusPrice = Number(item.bonus_price)
          const cartNum = Number(item.cart_num)
          return total + bonusPrice * cartNum
        }
        return total
      }, 0)
    })

    // 计算购物车里赠送的内容
    const sendTotalBonusPrice = computed(() => {
      return gwcList.value.reduce((total, item) => {
        if (item.bonus) {
          const bonusPrice = Number(item.bonus_gift_price)
          return total + bonusPrice
        }
        return total
      }, 0)
    })

    // 计算购物车里返利的内容
    const totalRebatePrice = computed(() => {
      return gwcList.value.reduce((total, item) => {
        const rebateNum = Number(item.rebate_num)
        // 检查 rebateNum 是否为非零有效数字
        if (rebateNum) {
          const rebate = Number(item.rebate_gift_price) || 0
          const cartNum = Number(item.cart_num) || 0
          const maxRebateNum = rebateNum > 0 ? rebateNum : 99
          const max = Math.min(cartNum, maxRebateNum)
          const effectiveRebate = rebate * max
          return total + effectiveRebate
        }
        return total
      }, 0)
    })

    // 非购物车里返利的内容（单个）
    const totalRebateSec = computed(() => {
      let choice = choiceItem.value
      let step = Number(buyNowStep.value)
      if (!choice) return 0
      let rebate = Number(choice.rebate_gift_price)
      let rebateNum = choice.rebate_num > 0 ? Number(choice.rebate_num) : 99
      let effectiveStep = step <= rebateNum ? step : rebateNum
      return rebate * effectiveStep
    })
    // 步进器最大值计算
    const canBuyNum = (e) => {
      if (!e) return 99
      const canBuyNumber = Number(e.quantity) - Number(e.game_stock)
      return canBuyNumber > 0 ? canBuyNumber : 0
    }

    const canBuyNumGwcOne = (e) => {
      let num = 0
      if (e.type == 3) {
        num = Number(e.quantity) - Number(e.game_stock)
      } else num = 99
      return num
    }
    // 监听购物车内的滚动
    const openGwcList = () => {
      if (container.value) {
        container.value.addEventListener("scroll", debouncedHandleScroll)
        let scrollTop = container.value.scrollTop
        let containerHeight = container.value.clientHeight
        let contentHeight = container.value.scrollHeight
        // 距离底部的距离
        let distanceToBottom = contentHeight - (scrollTop + containerHeight)
        if (distanceToBottom <= 220) {
          scrollBot.value = false
        } else scrollBot.value = true
      }
    }
    const closeGwcList = () => {
      if (container.value) {
        container.value.removeEventListener("scroll", debouncedHandleScroll)
      }
    }
    // 步进器事件
    const reduceBtn = (e) => {
      e.cart_num--
    }
    const addBtn = (e) => {
      e.cart_num++
    }
    //商品图下方赠送数量计算
    const productOtherPrice = (e) => {
      let bonusGift = 0
      let rebateNum = 0
      if (e.bonus) {
        bonusGift = Number(e.bonus_gift_price)
      }
      if (e.rebate_gift_price && e.rebate_num > 0) {
        rebateNum = Number(e.rebate_gift_price)
      }
      return bonusGift + rebateNum
    }
    //步进器最大值监听
    const overlimit = () => {
      showToast("不能再点啦～商品已达最大购买限制")
    }
    //商品详情积分浮点数处理
    const jfFormatter = (priceNum, num) => {
      if (num == 0) return 0
      if (!priceNum) return 0

      const price = new Decimal(priceNum).times(num)
      return price
    }
    // 商品详情积分浮点数处理（针对单个商品）
    const firTopUpFormatter = (priceNum, num) => {
      if (num == 0) return 0
      const nums = num + 1
      const price = new Decimal(priceNum).times(nums)
      return price
    }
    const closeWechatAlipay = () => {
      showWechatAlipay.value = false
      payType.value = "wechat"
    }
    // 版本检测
    const currentVersion = ref("1.3.4") // 当前版本号
    const checkVersion = async () => {
      try {
        const response = await fetch(
          `/version.json?t=${new Date().getTime()}`,
          { cache: "no-store" }
        )
        const data = await response.json()
        if (data.version !== currentVersion.value) {
          clearInterval(intervalId.value)
          showDialog({
            title: "更新提醒",
            message: "有新的内容需要更新哦，劳烦您刷新页面吧~",
            theme: "round-button",
            confirmButtonText: "刷新页面",
            confirmButtonColor: "#8383FF",
          }).then(() => {
            // 刷新页面
            location.reload()
          })
        }
      } catch (error) {
        console.error("Error fetching version:", error)
      }
    }
    const shareImgPopup = ref(false) //分享弹窗状态
    // 悬浮窗口奖励领取
    const getReward = () => {
      if (!localStorage.getItem("token")) {
        return bus.$emit("click") //未登录调取登录接口
      }
      shareImgPopup.value = true
      const quantity = Number(list.value.suspension_quantity)
      const stock = Number(list.value.suspension_stock)
      if (quantity < 0 || quantity === stock) return
      reward({
        game_id: gameId.value,
        role_id: chooseGameList.value.role_id,
        os: sysTem.value,
        server_id:
          chooseGameList.value.dist_id || chooseGameList.value.server_id,
        role_name:
          chooseGameList.value.nickname || chooseGameList.value.role_name,
        server_name:
          chooseGameList.value.dist_name || chooseGameList.value.server_name,
      }).then((res) => {
        // if (res.code != 200) return showToast(res.message)
        if (res.code == 200) {
          getListDetails()
        }
      })
    }

    const copy = () => {
      let clipboard = new Clipboard("#copyBtn")
      clipboard.on("success", () => {
        showToast("已复制到粘贴板，分享给好友一起来官网充值享受优惠与福利活动~")
        clipboard.destroy()
      })
      clipboard.on("error", (e) => {
        console.log(e)
        showToast("操作失败请重试！")
        clipboard.destroy()
      })
    }
    const showActiveIcon = ref(false) //是否显示活动icon
    const activeIconNum = (e) => {
      const quantity = Number(e.suspension_quantity)
      const stock = Number(e.suspension_stock)
      return quantity > 0 ? Math.max(quantity - stock, 0) : 0
    }

    // 首充奖励计算（非购物车）
    const firTopUp = (e) => {
      const price = new Decimal(e).times(2)
      return price
    }
    // 首充奖励计算（购物车）
    const firTopUpGwc = computed(() => {
      return gwcList.value
        .reduce((total, item) => {
          if (item.points_mark_img) {
            const bonusPrice = new Decimal(item.price).times(1)
            return total.plus(bonusPrice)
          }
          return total
        }, new Decimal(0))
        .toNumber() // 转换回普通的数字类型
    })
    // 合计积分计算（购物车）
    const doublePriceCompute = () => {
      finalPriceResult.value = 0
      const halfFirTopUpGwc = new Decimal(firTopUpGwc.value) // 确保转换为 Decimal
      const finalPrice = totalPrice.value.plus(halfFirTopUpGwc)
      return finalPrice.toNumber()
    }
    return {
      pointsMallContainer,
      firTopUpFormatter,
      finalPriceResult,
      doublePriceCompute,
      firTopUpGwc,
      firTopUp,
      getReward,
      activeIconNum,
      showActiveIcon,
      copy,
      shareImgPopup,
      getReward,
      giftSetPay,
      imgAni,
      clickBlock,
      storeInfo,
      addPlus,
      cart,
      gwcAni,
      intervalId,
      checkVersion,
      closeWechatAlipay,
      jfFormatter,
      overlimit,
      canBuyNumGwcOne,
      canBuyNum,
      productOtherPrice,
      addBtn,
      reduceBtn,
      chooseRoleGameId,
      scrollBot,
      closeGwcList,
      openGwcList,
      container,
      totalRebateSec,
      totalRebatePrice,
      sendTotalBonusPrice,
      totalBonusPrice,
      gameRoleTitle,
      gameRoleList,
      gwcPayType,
      skuListSec,
      getRoleNew,
      skuList,
      gwcSetPay,
      updateGwcList,
      delGwcList,
      showBonus,
      payTypeClass,
      payTypeText,
      gwcList,
      addToCartSec,
      openGwc,
      stepResultSheet,
      closeResultSheet,
      isGwc,
      buyNowStep,
      buyNowProduct,
      buyNow,
      totalPrice,
      gwcNum,
      addToCart,
      stepperChange,
      showGwcPopup,
      showType,
      kfBtn,
      roleList,
      goExchangePage,
      goPointsDetail,
      pointsNum,
      showCashCoupon,
      roleIndex,
      validateIDCard,
      loginOut,
      loginType,
      mobile,
      loginBtn,
      getListDetails,
      showH5Pay,
      showH5PayPopup,
      wechatPayTest,
      role_id,
      tradeNum,
      goRuler,
      getOpenId,
      wechatTradeNo,
      pcWechat,
      qrcodes,
      closeQrcode,
      showWechatCode,
      qrcode,
      payMethods,
      chooseGameList,
      confirmChoose,
      changePay,
      payType,
      areaList,
      chooseArea,
      gameId,
      chooseSystem,
      sysTem,
      show,
      showGameRole,
      interPage,
      setPay,
      choiceItem,
      list,
      choicePay,
      randomRange,
      isMobile,
      isWeiXin,
      showAliPay,
      showH5Details,
      closeRolePopup,
      gameListTop,
      nowGameListType,
      choiceIndex,
      showWechatAlipay,
      realNamePopup,
      updataUserBtn,
      userName,
      cardIdNum,
      otherList,
      channelType,
      latelyPayRole,
      LoginByNoSignIn,
      distanceAmount,
      longW,
      hLongW,
      iconW,
      amountPaid,
      rechargeCategoryList,
      rechargeTitle,
      rechargePhase,
      goJfMallPage,
      dottedLeft,
      dottedW,
      logger,
      goJfMallPage,
      progressWidth,
      rechargeBodyWidth,
      stepperChangeSec,
      updateCartList,
      isActivity,
    }
  },
}
